import { Injectable, Injector } from '@angular/core'
import { Location } from '@angular/common'
import { DynamicElementInterceptor, DynamicElementSpecification } from '@view-app/dynamic'
import { ActivatedRoute, Router } from '@angular/router'

/**
 * An interceptor that will ensure that router links are properly created to be relative
 * to the current active route.
 */
@Injectable({ providedIn: 'root' })
export class LinkElementInterceptor implements DynamicElementInterceptor {

  /**
   * Hook to update the args before the element is built.
   *
   * Update the href data of the element, so that any router links are fully evaluated as
   * an URL in the router can recognize.
   *
   * @param injector  The injector context for this element
   * @param args      The pending arguments for the dynamic element
   * @param _config   Unused
   *
   * @returns
   */
  beforeBuild(injector: Injector, args: DynamicElementSpecification, _config: unknown) {
    let router = injector.get<Router>(Router)
    let location = injector.get<Location>(Location)

    // If there is a router link argument, we need to update the href
    let routerLink = args.data?.routerLink as string
    if (routerLink) {
      // Get the route
      let route = injector.get<ActivatedRoute>(ActivatedRoute)
      while (route.firstChild) {
        route = route.firstChild
      }

      // Create a routing command
      let params = args.data?.queryParams
      let commands = params ? [ routerLink, params ] : [ routerLink ]

      // Convert the command to a URL
      let urlTree = router.createUrlTree(commands, { relativeTo: route })
      args.data.href = location.prepareExternalUrl(urlTree.toString())
    }

    return args
  }

}
